import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CommonService } from '../../../services/common_Service/common.service';
import { GeoZoneService } from '../../../services/geo_zone/geo_zone.service';

@Component({
  selector: 'app-geozone-box',
  templateUrl: './geozoneselection-box.component.html',
  styleUrls: ['./geozoneselection-box.component.scss']
})
export class GeozoneselectionBoxComponent implements OnInit {

    @Output() isGeoZoneActionSend = new EventEmitter<any>();

    // synthetic "All Geo Zones" option used to clear the global scope.
    readonly ALL_GEOZONE_ID = 'all';

    geoZoneList: any = [];

    loader: boolean = false;

    @Input() shareMassage;

    constructor(private commonService: CommonService, private geoZoneService: GeoZoneService) { }

    ngOnInit() {
      this.getGeoZoneInfo();
    }

    onAction(event) {
        this.isGeoZoneActionSend.emit(event);
    }

    getGeoZoneInfo() {

      this.loader = true;

      this.geoZoneService.getAllGeoZone({}, 0, 10000).subscribe((result: any) => {

        this.geoZoneList = [];

        const activeGeoZoneId = localStorage.getItem('geoZoneId');

        // first option lets the user clear the scope and see everything.
        this.geoZoneList.push({
          geoZoneId: this.ALL_GEOZONE_ID,
          geoZoneName: 'All Geo Zones',
          selected: (activeGeoZoneId == null || activeGeoZoneId == '' || activeGeoZoneId == this.ALL_GEOZONE_ID)
        });

        if (result && result.data && result.data.data && result.data.data.length > 0) {

          result.data.data.forEach(element => {

            element.selected = false;

            if (activeGeoZoneId != null && activeGeoZoneId != '' &&
                String(activeGeoZoneId) == String(element.geoZoneId)) {
              element.selected = true;
            }

            this.geoZoneList.push(element);
          });
        }

        this.loader = false;
      }, () => {
        this.loader = false;
      });
    }

    onGeoZone(geoZone) {

      this.geoZoneList.forEach(element => {
        element.selected = (element.geoZoneId == geoZone.geoZoneId);
      });
    }

    onSubmit() {

      this.loader = true;

      const selected = this.geoZoneList.find(element => element.selected == true);

      if (selected && selected.geoZoneId != this.ALL_GEOZONE_ID) {
        localStorage.setItem('geoZoneId', selected.geoZoneId);
        localStorage.setItem('geoZoneName', selected.geoZoneName);
      } else {
        // "All Geo Zones" => clear the scope so lists show everything.
        localStorage.removeItem('geoZoneId');
        localStorage.removeItem('geoZoneName');
      }

      // notify every geo-zone-aware list to re-fetch with the new scope.
      this.commonService.changeThemeGeoZone(true);
      this.isGeoZoneActionSend.emit(event);

      this.loader = false;
    }
}
